// TODO: localize
export const text = {
    table: `table`,
    colors: {
        gray: `Gray`,
        white: `White`,
        brown: `Brown`,
        orange: `Orange`,
        yellow: `Yellow`,
        green: `Green`,
        blue: `Blue`,
        purple: `Purple`,
        pink: `Pink`,
        red: `Red`,
    },
    tableActions: {
        insertRowAbove: `Insert row above`,
        insertRowBelow: `Insert row below`,
        insertColumnLeft: `Insert column left`,
        insertColumnRight: `Insert column right`,
        mergeCells: `Merge cells`,
        splitCell: `Split cell`,
        toggleHeaderColumn: `Toggle header column`,
        toggleHeaderRow: `Toggle header row`,
        deleteColumn: `Delete column`,
        deleteRow: `Delete row`,
        deleteTable: `Delete table`,
        setBackgroundColor: `Set background color`,
        none: `None`,
    },
    confirmDialog: {
        title: `Are you sure?`,
        description: `Are you sure you want to delete this table?`,
        cancel: `No, cancel`,
        confirm: `Yes, delete this table`,
    },
};
